module.exports = __webpack_public_path__ + "img/gp.5bc37b1a.jpeg";